import React from "react"
import { useTranslation } from "react-i18next"

import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"
import { ProductConfiguratorModeSelect } from "shared/ui/product-configurator-mode-select/ProductConfiguratorModeSelect"

import { ProductConfiguratorModeSelectOverlayModel } from "../ProductConfiguratorModeSelectOverlay"
import "../styles/_product-configurator-mode-select-overlay.scss"

interface ProductConfiguratorModeSelectViewModel
  extends ProductConfiguratorModeSelectOverlayModel {}

export const ProductConfiguratorModeSelectOverlayView = React.memo(
  ({
    title,
    image,
    isConfigurationAvailable,
    isExternalDimensioningAvailable,
    onConfigurationSelect,
    onDimensioningSelect,
    closeOverlay
  }: ProductConfiguratorModeSelectViewModel) => {
    const { t } = useTranslation()

    return (
      <OverlayWrapper
        id="product-config-mode-select-overlay"
        className="product-config-mode-select-overlay"
        classNamePrefix="product-config-mode-select-overlay"
        headline={`${t("Product.Configuration.Configuration")} ${title}`}
        mobileFullscreen
      >
        <OverlayHeader.Container responsive>
          <OverlayHeader.CloseButton
            onClick={closeOverlay}
            className="primary"
          />
          <OverlayHeader.Title>{title}</OverlayHeader.Title>
        </OverlayHeader.Container>
        <ProductConfiguratorModeSelect
          image={image}
          isConfigurationAvailable={isConfigurationAvailable}
          isExternalDimensioningAvailable={isExternalDimensioningAvailable}
          onConfigurationSelect={onConfigurationSelect}
          onDimensioningSelect={onDimensioningSelect}
        />
      </OverlayWrapper>
    )
  }
)
